import { flatui_proxy } from '../../utils';

export const fetch_devices_psirt = (adomOid) => {
  const url = `/gui/adoms/${adomOid}/dvm/psirt`;
  return flatui_proxy({
    url,
    method: 'get',
  });
};
